<style scoped>
  .selected { font-weight: bold }
  li { cursor: pointer }
</style>

<template>
  <div class="col-xs-12 col-sm-6 attributesBlock sizeDropBlock">
    <span class="title" v-html="`${attributeGroup.attributeGroupName} ${getSelectedText}`"></span>
    <button class="selectDropSize" v-on:click="visible = !visible">{{ getSelectedText || t('selection') }}
      <i class="fa fa-angle-down"></i>
    </button>
    <div v-show="visible" class="toggleAttrsBlk">
      <ul>
        <li v-for="attribute in attributeGroup.attributes"
            :key="attribute.attributeId"
            v-on:click="setSelected(attribute.attributeId)"
            :class="selected === attribute.attributeId ? 'selected' : ''">
          {{ attribute.attributeName }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttributeTextSelector',
  props: ['attributeGroup'],
  data () {
    return {
      version: '0.0.2',
      visible: false,
      selected: null
    }
  },
  computed: {
    getSelectedText () {
      if (!this.selected) {
        return ''
      }
      let selected = this.attributeGroup.attributes.find(item => item.attributeId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.attributeName
    }
  },
  methods: {
    setSelected (attributeId) {
      this.selected = attributeId
      this.visible = false
      this.$emit('attribute-clicked', attributeId)
    }
  }
}
</script>
